var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.516,
    height: 46.516,
    viewBox: "0 0 46.516 46.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M0,0H46.516V46.516H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M21.382,2A19.382,19.382,0,1,0,40.763,21.382,19.389,19.389,0,0,0,21.382,2Zm0,5.814a5.814,5.814,0,1,1-5.814,5.814A5.807,5.807,0,0,1,21.382,7.814Zm0,27.522A13.956,13.956,0,0,1,9.753,29.1c.058-3.857,7.753-5.97,11.629-5.97,3.857,0,11.571,2.113,11.629,5.97A13.956,13.956,0,0,1,21.382,35.336Z",
    transform: "translate(1.876 1.876)",
    fill: "#b4bac2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account_circle.81e0b5c3a5c30523953feba9dbbfad56.svg";
export { ForwardRef as ReactComponent };